
// ==============================================
//    DYWANAH GLOBAL START
// ==============================================
// ==========================
// DYWANAH AT THE TOP OF THE theme.js FILE - SCROLL LOCK UTILITY START
// Used to prevent background scroll on mobile FOR smarttabs popups
// ==========================
let scrollY = 0;

function lockBodyScroll() {
  scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function unlockBodyScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);
}
// ==========================
// DYWANAH SCROLL LOCK UTILITY END
// ==========================

const productInfo = document.querySelector('.product-info');
// ==============================================
//    DYWANAH GLOBAL END
// ==============================================



//---- Custom code to change product card "color name text" to the selected swatch name.----//

document.addEventListener("DOMContentLoaded", function() {
    function updateSwatchText(event) {
        let swatch = event.target.closest(".swatch-view-item");
        if (!swatch) return; // Ignore clicks outside swatches

        let productCard = swatch.closest("product-card");
        if (!productCard) return; // Ensure it's inside a product card

        let colorText = productCard.querySelector("#current-product-color");
        if (!colorText) return; // Ensure the color text element exists

        let newColor = swatch.getAttribute("aria-label") || 
                       swatch.getAttribute("orig-value") || 
                       swatch.dataset.value;

        if (newColor) {
           // Remove any "- Sold Out" suffix
           newColor = newColor.replace(/\s*-\s*Sold\s*Out\s*/gi, '');
           colorText.textContent = newColor;
       }
    }

    // Attach event listener to the whole document but limit it to relevant elements
    document.body.addEventListener("click", function(event) {
        let targetParent = event.target.closest("product-list, scroll-carousel");
        if (targetParent) {
            updateSwatchText(event);
        }
    });

    // Re-run function after 1 second in case elements are delayed
    setTimeout(() => {
        document.querySelectorAll("product-list, scroll-carousel").forEach(list => {
            list.addEventListener("click", updateSwatchText, true);
        });
    }, 1000); // Adjust delay as needed
});


// ========================================================================================================================
// DYWANAH Badge System - Complete Solution
// - Badge System for All DYWANAH custom Badging sytem that include (NEW - On Sale - SOld Out ... etc) badges
// - Directly uses the swatch-generated attribute at the product-card level to determine the current color variant
// - Ensures SOLD OUT badge properly displays and takes precedence when switching to a sold-out variant
// - Correctly shows/hides ON SALE badge based on the selected variant's sale status
// - Works for both initial load and when switching between colors                                         START 
// =======================================================================================================================

document.addEventListener('DOMContentLoaded', () => {
  // Small delay to ensure the DOM is fully loaded
  setTimeout(() => {
    // Set up badge behavior on all product cards
    setupBadgeBehavior();

    // Remove any conflicting badges
    removeInjectedBadges();
  }, 1500);
});

// Helper function to check if a card's current variant is sold out
function checkCardSoldOutStatus(card) {
  // First check if the card has a sold-out class
  if (card.classList.contains('soldout') || 
      card.classList.contains('sold-out') || 
      card.classList.contains('swatch-variant-soldout') || 
      card.hasAttribute('swatch-variant-soldout')) {
    return true;
  }
  
  // Check if sold-out badge is visible
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  if (soldOutBadge && window.getComputedStyle(soldOutBadge).display !== 'none') {
    return true;
  }
  
  return false;
}

function setupBadgeBehavior() {
  // Process all product cards
  document.querySelectorAll('.product-card').forEach(card => {
    // Get the badges on this card
    const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
    const saleBadge = card.querySelector('[data-badge-type="sale"]');
    const newBadge = card.querySelector('[data-badge-type="new"]');
    const priceList = card.querySelector('.price-list');
    
    // Skip if no badges found
    if (!soldOutBadge && !saleBadge && !newBadge) return;
    
    // Track which variant is displayed
    updateBadgeStates(card);

    // Watch for attribute changes on the product card
    const observer = new MutationObserver(() => {
      updateBadgeStates(card);
      // Also update price list visibility when attributes change
      const currentSoldOutState = checkProductSoldOutStatus(card);
      if (priceList) {
        priceList.style.display = currentSoldOutState ? 'none' : '';
      }
    });
    
    // Observe relevant attribute changes
    observer.observe(card, { 
      attributes: true, 
      attributeFilter: ['swatch-generated', 'class', 'swatch-variant-soldout'] 
    });
    
    // Also handle clicks on swatches for backup
    card.addEventListener('click', event => {
      const swatch = event.target.closest('.swatch-view-item, .color-swatch, .swatch-element');
      if (swatch) {
        // Give it a moment for attributes to update
        setTimeout(() => {
          updateBadgeStates(card);
          const currentSoldOutState = checkProductSoldOutStatus(card);
          if (priceList) {
            priceList.style.display = currentSoldOutState ? 'none' : '';
          }
        }, 150);
        
        // Check again after a bit longer
        setTimeout(() => {
          updateBadgeStates(card);
          const currentSoldOutState = checkProductSoldOutStatus(card);
          if (priceList) {
            priceList.style.display = currentSoldOutState ? 'none' : '';
          }
        }, 1500);
      }
    });
  });
}

// Function to check if a product is sold out using the same comprehensive logic as updateBadgeStates
function checkProductSoldOutStatus(card) {
  // Direct class checks
  let isSoldOut = card.classList.contains('swatch-variant-soldout') || 
                 card.hasAttribute('swatch-variant-soldout') ||
                 card.classList.contains('soldout') || 
                 card.classList.contains('sold-out');
  
  if (isSoldOut) return true;
  
  // Get the current color variant from swatch-generated
  const swatchGenerated = card.getAttribute('swatch-generated') || '';
  const handle = card.getAttribute('handle') || '';
  
  // Check product data
  if (swatchGenerated) {
    const productData = card.querySelector('.dywanah-product-data');
    if (productData) {
      try {
        const data = JSON.parse(productData.textContent);
        
        // Get the color from swatch-generated
        const colorParts = swatchGenerated.split('-');
        const color = colorParts[colorParts.length - 1]; // Last part is color
        
        // Find if any variant with this color is unavailable
        for (const variant of data.variants) {
          if (!variant.available) {
            // Check if this unavailable variant matches our current color
            if (swatchGenerated.includes(handle) && 
                swatchGenerated.includes(color)) {
              return true;
            }
          }
        }
      } catch (e) {
        // Silent error handling
      }
    }
  }
  
  // Check for SOLD OUT button
  const soldOutButton = card.querySelector('.sold-out-button');
  if (soldOutButton) {
    return true;
  }
  
  // Check if sold-out badge is visible
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  if (soldOutBadge && window.getComputedStyle(soldOutBadge).display !== 'none') {
    return true;
  }
  
  return false;
}

function updateBadgeStates(card) {
  // Get badge elements
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  const saleBadge = card.querySelector('[data-badge-type="sale"]');
  const newBadge = card.querySelector('[data-badge-type="new"]');
  
  // Skip if no badges
  if (!soldOutBadge && !saleBadge && !newBadge) return;
  
  // Get the current color variant from swatch-generated
  const swatchGenerated = card.getAttribute('swatch-generated') || '';
  const handle = card.getAttribute('handle') || '';
  
  // Determine if the variant is sold out - start with direct class checks
  let isSoldOut = card.classList.contains('swatch-variant-soldout') || 
                  card.hasAttribute('swatch-variant-soldout');
  
  // Look for soldout class at card level
  if (card.classList.contains('soldout') || card.classList.contains('sold-out')) {
    isSoldOut = true;
  }
  
  // If direct indicators don't show sold out, check product data
  if (!isSoldOut && swatchGenerated) {
    const productData = card.querySelector('.dywanah-product-data');
    if (productData) {
      try {
        const data = JSON.parse(productData.textContent);
        
        // Get the color from swatch-generated
        const colorParts = swatchGenerated.split('-');
        const color = colorParts[colorParts.length - 1]; // Last part is color
        
        // Find if any variant with this color is unavailable
        for (const variant of data.variants) {
          if (!variant.available) {
            // Check if this unavailable variant matches our current color
            if (swatchGenerated.includes(handle) && 
                swatchGenerated.includes(color)) {
              isSoldOut = true;
              break;
            }
          }
        }
      } catch (e) {
        // Silent error handling
      }
    }
  }
  
  // Check for SOLD OUT direct from class (another indicator)
  const soldOutClass = card.querySelector('.sold-out-button') !== null;
  if (soldOutClass) {
    isSoldOut = true;
  }
  
  // Check for ON SALE state
  const compareAtPrice = card.querySelector('compare-at-price');
  const salePrice = card.querySelector('sale-price');
  const isOnSale = compareAtPrice && salePrice && 
                  window.getComputedStyle(compareAtPrice).display !== 'none' &&
                  compareAtPrice.textContent.trim() !== '';
  
  // Update badge visibility
  if (isSoldOut) {
    // Sold out - show SOLD OUT badge, hide others
    if (soldOutBadge) soldOutBadge.style.display = 'block';
    if (saleBadge) saleBadge.style.display = 'none';
    if (newBadge) newBadge.style.display = 'none';
  } else {
    // Not sold out
    if (soldOutBadge) soldOutBadge.style.display = 'none';
    
    // Handle SALE badge
    if (saleBadge) {
      saleBadge.style.display = isOnSale ? 'block' : 'none';
      
      // Update discount percentage if needed
      if (isOnSale) {
        try {
          const compareValue = parseFloat(compareAtPrice.textContent.replace(/[^0-9.]/g, ''));
          const saleValue = parseFloat(salePrice.textContent.replace(/[^0-9.]/g, ''));
          
          if (compareValue > saleValue) {
            const discountPercentage = Math.round(((compareValue - saleValue) / compareValue) * 100);
            const percentSpan = saleBadge.querySelector('span');
            if (percentSpan) {
              percentSpan.textContent = `${discountPercentage}% OFF`;
            }
          }
        } catch (e) {
          // Silent error handling
        }
      }
    }
    
    // Show NEW badge if it exists
    if (newBadge) {
      newBadge.style.display = 'block';
    }
  }
}

// Remove any conflicting badges from other systems
function removeInjectedBadges() {
  document.querySelectorAll('.badge-list').forEach(el => el.remove());
}

// Clean up injected badges when new ones are added
const badgeObserver = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      for (const node of mutation.addedNodes) {
        if (node.classList && node.classList.contains('badge-list')) {
          node.remove();
        }
      }
    }
  }
});

// Start watching for injected badges
badgeObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Clean badges on initial load
setTimeout(removeInjectedBadges, 500);

// ========================================================================================================================
// DYWANAH Badge System - Complete Solution
// - Badge System for All DYWANAH custom Badging sytem that include (NEW - On Sale - SOld Out ... etc) badges
// - Directly uses the swatch-generated attribute at the product-card level to determine the current color variant
// - Ensures SOLD OUT badge properly displays and takes precedence when switching to a sold-out variant
// - Correctly shows/hides ON SALE badge based on the selected variant's sale status
// - Works for both initial load and when switching between colors                                         END 
// =======================================================================================================================


// ========================================================================================================================
// DYWANAH Script to help visually differentiate discounted product prices on product cards.
// When a discount exists, the compare-at-price element is shown; otherwise, it is removed.
// This supports styling the price element in the product card with a specific colour based on discount presence.   - START
// =======================================================================================================================

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelectorAll('.product-card').forEach((productCard) => {
      const priceList = productCard.querySelector('.price-list');
      if (!priceList) return;

      const observePriceList = (node) => {
        const priceObserver = new MutationObserver(() => {
          const compareAtPrice = node.querySelector('compare-at-price');
          if (compareAtPrice && compareAtPrice.style.display === 'none') {
            compareAtPrice.remove();
          }
        });
        priceObserver.observe(node, { childList: true, subtree: true });
      };

      observePriceList(priceList);

      const cardObserver = new MutationObserver(() => {
        const updatedPriceList = productCard.querySelector('.price-list');
        if (updatedPriceList && updatedPriceList.innerHTML !== priceList.innerHTML) {
          observePriceList(updatedPriceList);
        }
      });

      cardObserver.observe(productCard, { childList: true, subtree: true });
    });
  }, 2000); // Delay to wait for lazy-loaded cards
});
// ========================================================================================================================
// DYWANAH Script to help visually differentiate discounted product prices on product cards.
// When a discount exists, the compare-at-price element is shown; otherwise, it is removed.
// This supports styling the price element in the product card with a specific colour based on discount presence.   - END
// ========================================================================================================================


//--------------- Custom code to Remove Default Product Card Badges Used by Swatch King App-----------------//
function removeInjectedBadges() {
  document.querySelectorAll('.badge-list').forEach(el => el.remove());
}

const observer = new MutationObserver(() => {
  removeInjectedBadges();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Clean on initial load
removeInjectedBadges();

//----- Custom code to expand gallery list images on Desktop.------//

const expandBtn = document.querySelector('.dywanah-expand-gallery-btn');
const imageList = document.querySelector('.product-gallery__image-list');
const fadeBottom = document.querySelector('.dywanah-gallery-fade-bottom');

if (expandBtn && imageList && fadeBottom) {
  expandBtn.addEventListener('click', () => {
    imageList.classList.add('dywanah-gallery-expand');
    fadeBottom.style.display = 'none';
  });
}


// ================== Custom code to PRODUCT SMARTTABS POPUP ================== //

// Move tab popup wrapper to <body> to appear above the page navigation header on desktop

document.addEventListener("DOMContentLoaded", function () {
    const popupWrapper = document.getElementById("tab-popup-backdrop");
    if (popupWrapper) {
      document.body.appendChild(popupWrapper);
    }
  });
  
  // Utility to extract only the pure text node (ignores icons, SVG, etc.)
  function getTabLabel(tabElement) {
    for (let node of tabElement.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        return node.textContent.trim();
      }
    }
    return 'تفاصيل'; // Fallback if nothing is found
  }
  
  // Delegated click listener to support dynamic tabs
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.smart-tabs-navigation-li');
    const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
    if (!tab) return;
  
    const tabId = tab.getAttribute('data-tab-link-id');
    const contentId = `smart-tabs-content-${tabId}`;
    const tabLabel = getTabLabel(tab); // Use clean label only
  
    setTimeout(() => {
      const content = document.querySelector(`#${contentId}`);
      if (content) {
        const popup = document.getElementById('tab-popup'); // Now inside moved wrapper
        const popupWrapper = document.getElementById("tab-popup-backdrop");
        const popupBody = popup.querySelector('.tab-popup-body');
        const popupTitle = document.getElementById('tab-popup-title');
  
        popupBody.innerHTML = content.innerHTML;
        popupTitle.textContent = tabLabel;
  
        popup.classList.add('open');
        popupWrapper.classList.add('open');
        lockBodyScroll();
      } else {
        console.warn(`Tab content with ID #${contentId} not found`);
      }
    }, 100);
    StickyCart.style.zIndex = '0';
    if (productInfo) {
    productInfo.style.position = 'relative'; // or 'static'
    productInfo.classList.add('top');
    }
  });
  
  // Close popup when clicking on the close button
  document.querySelector('.tab-popup-close')?.addEventListener('click', () => {
    const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
    document.getElementById('tab-popup')?.classList.remove('open');
    document.getElementById('tab-popup-backdrop')?.classList.remove('open');
    unlockBodyScroll();
    StickyCart.style.zIndex = '10';
    if (productInfo) {
    productInfo.style.position = 'sticky';
    productInfo.classList.remove('top');
    }
  });
  
  // Close popup when clicking outside (on backdrop)
  document.getElementById('tab-popup-backdrop')?.addEventListener('click', function (e) {
    const popup = document.getElementById('tab-popup');
    const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
    if (!popup.contains(e.target)) {
      popup.classList.remove('open');
      this.classList.remove('open');
      unlockBodyScroll();
      StickyCart.style.zIndex = '10';
      if (productInfo) {
      productInfo.style.position = 'sticky';
      productInfo.classList.remove('top');
     }
    }
  });


// ================== Custom code to Change Text With Media Section Color Styling on Product Page ================== //
document.addEventListener('DOMContentLoaded', function () {
    var styles = ['DYWANAH-random-Background-1e1f20', 'DYWANAH-random-Background-f2f2f2'];
    var randomIndex = Math.floor(Math.random() * styles.length);
    document.querySelector('.DYWANAH-ProductPage-media-with-text-section')?.classList.add(styles[randomIndex]);
  });




// ================== Custom code To Trigger Tabby and Tamara Installment Pupop on Clicking on Installment Liquid Block  ================== //

// The Code To Trigger Tabby Popup
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('DYWANAH-showTabbyPopup');

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    let attempts = 10;

    const tryClick = () => {
      const promo = document.querySelector('#TabbyPromo');
      if (!promo) return;

      const hosts = promo.querySelectorAll('span');
      for (const host of hosts) {
        const shadow = host.shadowRoot;
        const link = shadow?.querySelector('[data-test="widget-learn-more"]');
        if (link) {
          link.click();
          return true;
        }
      }
      return false;
    };

    if (tryClick()) return;

    const interval = setInterval(() => {
      if (tryClick() || --attempts <= 0) clearInterval(interval);
    }, 300);
  });
});

// The Code To Trigger Tamara Popup
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('DYWANAH-showTamaraPopup');

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    let attempts = 10;

    const tryClick = () => {
      const widget = document.querySelector('tamara-widget');
      if (!widget) return false;

      const shadow = widget.shadowRoot;
      const link = shadow?.querySelector('.tamara-inline-learn-more-link');

      if (link) {
        link.click();
        return true;
      }

      return false;
    };

    if (tryClick()) return;

    const interval = setInterval(() => {
      if (tryClick() || --attempts <= 0) clearInterval(interval);
    }, 300);
  });
});

// ================== Custom code For Footer Accordion on Mobile ================== //
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 700) return;

  document.querySelectorAll('.DYWANAH-footer-accordion__header').forEach(function(header) {
    function toggleAccordion() {
      console.log('Accordion header clicked!');
      const content = header.nextElementSibling;
      const isOpen = header.classList.toggle('active');
      header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (content && content.classList.contains('DYWANAH-footer-accordion__content')) {
        content.classList.toggle('active', isOpen);
      }
    }

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion();
      }
    });
  });
});

// ================== Custom code For Footer VAT Popup Control ================== //

  function openVatPopup() {
    document.getElementById('vat-popup').classList.add('active');
    document.getElementById('vat-popup-overlay').classList.add('active');
    document.body.classList.add('vat-modal-open');
  }

  function closeVatPopup() {
    document.getElementById('vat-popup').classList.remove('active');
    document.getElementById('vat-popup-overlay').classList.remove('active');
    document.body.classList.remove('vat-modal-open');
  }






              
